import { Page, View, Text, Link } from '@react-pdf/renderer';
import { styles } from './styles';
import { PublicEventDetailsResponse } from '@hubs101/booking-api-skd-client/lib/types';
import { globalStyles } from '../../styles';
import { useTranslation } from 'react-i18next';
import { APP_HOST } from '@utils/apiHooks';
import { SafeImage } from '@composites/PDF/AgendaPdfContent/components/SafeImage';

export interface ListOfAttendeesPageProps {
  event: PublicEventDetailsResponse;
  footer: JSX.Element;
}

const ListOfAttendeesPage = ({ event, footer }: ListOfAttendeesPageProps) => {
  const { t } = useTranslation();

  return (
    <Page
      size={{ width: 1440, height: 800 }}
      style={{ ...styles.page, overflow: 'hidden' }}
    >
      <View
        style={{
          ...styles.leftColumn,
        }}
      >
        <View
          style={{
            ...styles.imageRow,
            alignItems: 'flex-end',
            marginLeft: 40,
            marginBottom: 20,
          }}
        >
          <View style={{ width: 440, height: 270 }}>
            <SafeImage
              src="https://media.we-conect.com/images/pdf/partnerprospectus/list_of_attendees_1.png"
              style={{ ...styles.image, width: 440, height: 270 }}
            />
          </View>

          <View style={{ width: 280, height: 220 }}>
            <SafeImage
              src="https://media.we-conect.com/images/pdf/partnerprospectus/list_of_attendees_3.png"
              style={{ ...styles.image, width: 280, height: 220 }}
            />
          </View>
        </View>

        <View style={{ ...styles.imageRow, alignItems: 'flex-start' }}>
          <View style={{ width: 560, height: 360 }}>
            <SafeImage
              src="https://media.we-conect.com/images/pdf/partnerprospectus/list_of_attendees_2.png"
              style={{ ...styles.image, width: 560, height: 360 }}
            />
          </View>

          <View style={{ width: 240, height: 260 }}>
            <SafeImage
              src="https://media.we-conect.com/images/pdf/partnerprospectus/list_of_attendees_4.png"
              style={{ ...styles.image, width: 240, height: 260 }}
            />
          </View>
        </View>
      </View>

      <View style={styles.rightColumn}>
        <View>
          <Text style={{ ...styles.title }}>
            {t('list-of-attendees')?.toUpperCase()}
          </Text>

          <View
            style={{
              ...globalStyles.lineBar,
              borderColor: event?.design?.themeColor ?? 'black',
              marginLeft: 0,
            }}
          />
        </View>

        <Text style={{ ...styles.paragraph }}>
          {t('access-the-complete-attendee-list')}
        </Text>

        <Link
          src={`${APP_HOST}/events/${event?.slug}${t('community-url')}`}
          style={{
            ...styles.button,
            backgroundColor: event?.design?.themeColor,
            color: 'white',
          }}
        >
          <Text>{t('download-list-of-attendees')?.toUpperCase()}</Text>
        </Link>
      </View>

      {footer}
    </Page>
  );
};

export default ListOfAttendeesPage;
